import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { Kanban } from './pages/Kanban';
import { Clientes } from './pages/Clientes';
import { Ranking } from './pages/Ranking';
import { Campanhas } from './pages/Campanhas';
import { WhatsApp } from './pages/WhatsApp';
import { Configuracoes } from './pages/Configuracoes';
import { ToastProvider } from './components/ui/Toast';
export function App() {
  useEffect(() => {
    document.title = "Rota's Makeup";
  }, []);
  return <ToastProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Dashboard data-id="element-4" />} data-id="element-3" />
          <Route path="/kanban" element={<Kanban data-id="element-6" />} data-id="element-5" />
          <Route path="/clientes" element={<Clientes data-id="element-8" />} data-id="element-7" />
          <Route path="/ranking" element={<Ranking data-id="element-10" />} data-id="element-9" />
          <Route path="/campanhas" element={<Campanhas data-id="element-12" />} data-id="element-11" />
          <Route path="/whatsapp" element={<WhatsApp data-id="element-14" />} data-id="element-13" />
          <Route path="/configuracoes" element={<Configuracoes data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Router>
    </ToastProvider>;
}